import { render } from "./pagination-wrapper.vue?vue&type=template&id=0ad1811d&lang=pug"
import script from "./pagination-wrapper.vue?vue&type=script&lang=js"
export * from "./pagination-wrapper.vue?vue&type=script&lang=js"

import "./pagination-wrapper.vue?vue&type=style&index=0&id=0ad1811d&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__